import type { FaireProductEntity } from "../../entity_types/product";

export const p_kv3vdqny5c: FaireProductEntity = {
  token: "p_kv3vdqny5c",
  type: "product",
  name: "Seaside + Citrus - Mini Amber Jar Soy Candle",
  brandName: "Calyan Wax Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/0bc9341974e5cb180ae476a1a38ccf8d53c89d82911cf8c831a7a2b4f9956e2d.jpeg",
  priceDollars: 5.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/d72f2ef660ac42931dcf99cf9d292b153245832e4dedb0512eed3221c7f72f08.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
